export { VpCreatePluginDialog } from './VpCreatePluginDialog';



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpCreatePluginDialog/index.js